import { Typography, TypographyProps } from '@mui/material';
import { DpTextH2SX } from '@/components/blocks/DpLibrary/DPText/style';
import { combineSX } from '@/utils/combineSX';
import { Linkable } from '@/components/blocks/Linkable';

interface DpH2Props extends TypographyProps {
	href?: string;
}
export const DpH2 = ({ children, component, sx, href, ...props }: DpH2Props) => (
	<Typography
		component={component || 'h2'}
		sx={combineSX([DpTextH2SX, ...(Array.isArray(sx) ? sx : [sx])])}
		{...props}
	>
		<Linkable href={href}>{children}</Linkable>
	</Typography>
);
